import { useTranslation } from "react-i18next";
import { Box, Typography } from "@mui/material";
import { MouseEvent } from "react";
import { useAuth } from "@/features/auth";

export const AccountDetailsItem = () => {
  const { t } = useTranslation("coi-platform-translations");
  const { accountDetails, user } = useAuth();

  const handleClick = (event: MouseEvent) => {
    event.stopPropagation();
  };

  return (
    <Box
      bgcolor="grey.100"
      borderBottom="1px solid"
      borderColor="divider"
      data-testid="account-details"
      display="flex"
      flexDirection="column"
      gap="8px"
      padding="16px"
      onClick={handleClick}
    >
      <Box>
        <Typography
          color="text.secondary"
          data-testid="account-details__account-name-label"
          fontSize="10px"
          letterSpacing="1px"
          textTransform="uppercase"
          lineHeight="200%"
        >
          {t("navigation.account_details.account_name_label")}
        </Typography>
        <Typography data-testid="account-details__account-name-value" variant="body2" sx={{ wordWrap: "break-word" }}>
          {accountDetails?.name}
        </Typography>
      </Box>
      <Box>
        <Typography
          color="text.secondary"
          data-testid="account-details__user-email-label"
          fontSize="10px"
          letterSpacing="1px"
          textTransform="uppercase"
          lineHeight="200%"
          sx={{ wordWrap: "break-word" }}
        >
          {t("navigation.account_details.user_email_label")}
        </Typography>
        <Typography data-testid="account-details__user-email-value" variant="body2">
          {user?.email}
        </Typography>
      </Box>
    </Box>
  );
};
